import React from 'react'
import './styles.scss'
import { sumReduce, toPercent } from '../../functions'

interface Props extends answerTheQuestionProps {
  text?: (a: number, b: number, c: boolean) => string | JSX.Element
}

export const Summary = ({
  allAnswers,
  userAnswer,
  answeredCorrectly,
  text
}: Props) => {
  const entries = Object.values(allAnswers)
  const absTotal = +entries.map(m => +m).reduce(sumReduce, 0)
  const percentSameAsUser = toPercent(+allAnswers[userAnswer], absTotal)

  return (
    <div className='Summary'>
      {text && (
        <div className='text'>
          {text(absTotal, percentSameAsUser, answeredCorrectly)}
        </div>
      )}
    </div>
  )
}
